module.exports = __webpack_public_path__ + "img/av138.254009a0.png";